<div class="welcome-wrapper">
  <img src="assets/images/welcome.svg" alt="welcome" width="360" />
  <h1 *ngIf="currentUser" class="title is-1">
    Welcome {{ currentUser.firstName }} {{ currentUser.lastName }}
  </h1>
  <app-redirection-button></app-redirection-button>
</div>
